import api from '@/store/api'

const state = {
  renderHealth: {},
  renderBots: null
}

const actions = {
  getRenderHealth: ({state, commit}) => {
    return api.getRenderHealth().then((renderHealth) => {
      return commit('setRenderHealth', renderHealth)
    })
  },
  getRenderBots: ({state, commit}) => {
    return api.getRenderBots().then((renderBots) => {
      return commit('setRenderBots', renderBots)
    })
  }
}

const mutations = {
  setRenderHealth (state, renderHealth) {
    state.renderHealth = renderHealth
  },
  setRenderBots (state, renderBots) {
    state.renderBots = renderBots
  }
}

const getters = {
  renderHealth: state => {
    return state.renderHealth
  },
  renderBots: state => {
    return state.renderBots
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/monitor.js